import { PaymentLinkResponse } from '@/pages/client-side/Payment/components/PaymentData'

import fetchClient, { ApiResponse } from '../api-client'
import { CheckCouponPayload } from './types/CheckCouponPayload'
import { CheckCouponResponse } from './types/CheckCouponResponse'
import { CreatePaymentLinkPayload } from './types/CreatePaymentLinkPayload'
import { CreateRPPaymentLinkPayload } from './types/CreateRPPaymentLinkPayload'
import { PaymentSummaryPayload } from './types/PaymentSummaryPayload'
import { PaymentSummaryResponse } from './types/PaymentSummaryResponse'
import { PkgPricesResponse } from './types/PkgPricesResponse'
import { RefundPaymentPayload } from './types/RefundPaymentPayload'
import { RefundPaymentResponse } from './types/RefundPaymentResponse'

export const getPaymentLink = async (payload: CreatePaymentLinkPayload) => {
  const res = await fetchClient.post<ApiResponse<PaymentLinkResponse>>('/payments/link', payload)
  return res.data.data
}

export const getPkgPrices = async (packageId: string): Promise<PkgPricesResponse> => {
  const res = await fetchClient.get<ApiResponse<PkgPricesResponse>>(`/payments/pkg-prices/${packageId}`)
  return res.data.data
}

export const getPaymentSummary = async (payload: PaymentSummaryPayload): Promise<PaymentSummaryResponse> => {
  const res = await fetchClient.post<ApiResponse<PaymentSummaryResponse>>('/payments/summary', payload)
  return res.data.data
}

export const checkCoupon = async (payload: CheckCouponPayload): Promise<CheckCouponResponse> => {
  try {
    const res = await fetchClient.post<ApiResponse<CheckCouponResponse>>('/coupons/check', payload)
    return res.data.data
  } catch (error) {
    throw error
  }
}

export const createPaymentLinkRP = async (payload: CreateRPPaymentLinkPayload): Promise<PaymentLinkResponse> => {
  const res = await fetchClient.post<ApiResponse<PaymentLinkResponse>>('/payments/getlink-returnPackage', payload)
  return res.data.data
}
export const refundPayment = async (payload: RefundPaymentPayload) => {
  const res = await fetchClient.post<ApiResponse<RefundPaymentResponse>>('/payments/packageRefund', payload)
  return res.data.data
}

export const cancelShipment = async (packageId: string) => {
  const res = await fetchClient.post<ApiResponse<{ refundAmount: number }>>('/payments/cancelShipment', { packageId })
  return res.data.data
}

export const verifyPayment = async (packageId: string): Promise<{ isPaid: boolean }> => {
  const res = await fetchClient.get<ApiResponse<{ isPaid: boolean }>>(`/payments/verify/${packageId}`)
  return res.data.data
}

export const TAX_FREE_THRESHOLD = 130
export const ID_REQUIRED_THRESHOLD = 150
